import script from "./OrderDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrderDetail.vue?vue&type=script&lang=ts&setup=true"

import "./OrderDetail.vue?vue&type=style&index=0&id=ada88b42&lang=less&scoped=true"

import exportComponent from "/Volumes/未命名/repos/qll-web-work/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ada88b42"]])

export default __exports__